import { Stack, Typography } from "@mui/material";
import { tokens } from "../../store/tokens";

const DetailSection = ({ title, children, noBorder = false, sx }) => (
  <Stack
    spacing={1}
    sx={{
      padding: "16px",
      borderBottom: noBorder ? "none" : `1px solid ${tokens.color.line}`,
      ...sx,
    }}
  >
    {title && (
      <Typography
        sx={{
          fontFamily: tokens.font.body,
          fontSize: "0.85rem",
          fontWeight: 700,
          color: tokens.color.ink,
        }}
      >
        {title}
      </Typography>
    )}
    {children}
  </Stack>
);

export default DetailSection;
